import { render, staticRenderFns } from "./PendingInvestigations.vue?vue&type=template&id=38775fee&"
import script from "./PendingInvestigations.vue?vue&type=script&lang=js&"
export * from "./PendingInvestigations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports